<form [formGroup]="schoolDistrictForm" class="row">
	<mat-form-field appearance="fill" class="col">
		<mat-label>
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="13"> </mat-spinner>
			</mat-icon>
			{{fieldLabel + (this.isMultiple ? '(s)' : '')}}
		</mat-label>

		<mat-select placeholder="Select School Districts" formControlName="schoolDistrictSelect"
			id="schoolDistrictSelect" *ngIf="this.isMultiple" (openedChange)="!disabled && loadData($event)"
			(selectionChange)="select($event.value)" multiple [required]="required"
			[panelClass]="'panel-location-multiple'">
			<mat-select-trigger *ngIf="selectedSchoolDistrictIds.length > 1">
				{{this.selectedSchoolDistrictName}}
				<span *ngIf="selectedSchoolDistrictIds.length > 1">
					(+{{selectedSchoolDistrictIds.length - 1}} {{selectedSchoolDistrictIds.length === 2 ? 'other' :
					'others'}})
				</span>
			</mat-select-trigger>

			<div class="padding-md text-center row gx-0">
				<div class="col">
					<button color="primary" mat-raised-button (click)="selectAll()">
						Select All
					</button>
				</div>
				<div class="col">
					<button color="accent" mat-raised-button (click)="deSelectAll()">
						Deselect All
					</button>
				</div>
			</div>

			<div class="padding-horizontal-md row gx-0">
				<mat-form-field class="col">
					<mat-label>
						Filter
					</mat-label>
					<input matInput type="string" placeholder="by name" formControlName="filter"
						(keydown)="$event.stopPropagation()" #filterRef />
				</mat-form-field>
			</div>

			<mat-paginator (page)="onPageChange($event)" [length]="filteredSchoolDistricts.length" [pageSize]="5"
				showFirstLastButtons [pageSizeOptions]="[5, 10, 25, 100]">
			</mat-paginator>

			<div class="text-center padding-md" *ngIf="isLoading">
				<mat-icon>
					<mat-spinner diameter="13"> </mat-spinner>
				</mat-icon>
				Loading
			</div>

			<mat-option [hidden]="true">
				Select
			</mat-option>
			<div class="scrollable-panel-location" [hidden]="isLoading">
				<mat-option *ngFor="let schoolDistrict of this.filteredSchoolDistrictsShow" [value]="schoolDistrict.ID">
					{{schoolDistrict.DISTRICTS}}
				</mat-option>
			</div>
		</mat-select>




		<mat-select placeholder="Select School District" formControlName="schoolDistrictSelect" *ngIf="!this.isMultiple"
			(openedChange)="!disabled && loadData($event)" (selectionChange)="select($event.value)"
			[required]="required" [panelClass]="'panel-location-single'">
			<mat-select-trigger *ngIf="selectedSchoolDistrictIds.length > 1">
				{{this.selectedSchoolDistrictName}}
			</mat-select-trigger>

			<div class="padding-md text-center row gx-0">
				<div class="col">
					<button color="accent" mat-raised-button (click)="deSelectAll(); close();">
						Deselect
					</button>
				</div>
			</div>

			<div class="padding-horizontal-md row gx-0">
				<mat-form-field class="col">
					<mat-label>
						Filter
					</mat-label>
					<input matInput type="string" placeholder="by name" formControlName="filter"
						(keydown)="$event.stopPropagation()" #filterRef />
				</mat-form-field>
			</div>

			<mat-paginator (page)="onPageChange($event)" [length]="filteredSchoolDistricts.length" [pageSize]="5"
				showFirstLastButtons [pageSizeOptions]="[5, 10, 25, 100]">
			</mat-paginator>

			<div class="text-center padding-md" *ngIf="isLoading">
				<mat-icon>
					<mat-spinner diameter="13"> </mat-spinner>
				</mat-icon>
				Loading
			</div>

			<mat-option [hidden]="true">
				Select
			</mat-option>
			<div class="scrollable-panel-location" [hidden]="isLoading">
				<mat-option *ngFor="let schoolDistrict of this.filteredSchoolDistrictsShow" [value]="schoolDistrict.ID">
					{{schoolDistrict.DISTRICTS}}
				</mat-option>
			</div>
		</mat-select>

	</mat-form-field>
</form>